// 全局组件注册 需要到coms这个目录下注册
 
export default {
  install(app) {
      const req = require.context('.', true, /\.vue$/);
      req.keys().forEach((item) => {
          const defaultObj = req(item).default;

          let name = item.split('/')[1];
          let newname = name.substring(0, name.indexOf("."))
          app.component(newname, defaultObj)
      });
  }
};